import React, { memo } from "react";

// styles
import "./style.scss";
import ButtonCardIcon from "components/ButtonCardIcon";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
function QuickLinks({ user }) {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="quickly-link">
      <ButtonCardIcon
        title={t("labels.absences")}
        icon="absence"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/absences`,
          });
        }}
      />
      <ButtonCardIcon
        title={t("layouts.navigation.classes")}
        icon="users"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/classes`,
          });
        }}
      />
      <ButtonCardIcon
        title={t("layouts.navigation.courses")}
        icon="book"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/сours`,
          });
        }}
      />
      <ButtonCardIcon
        title={t("labels.students")}
        icon="academic"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/etudiants`,
          });
        }}
      />
      <ButtonCardIcon
        title={t("layouts.navigation.users")}
        icon="person"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/utilisateurs`,
          });
        }}
      />
      {/*<ButtonCardIcon*/}
      {/*  title="Rapports"*/}
      {/*  icon="document"*/}
      {/*  className="link-button"*/}
      {/*  action={() => {*/}
      {/*    history.push({*/}
      {/*      pathname: `/rapports`,*/}
      {/*    });*/}
      {/*  }}*/}
      {/*/>*/}
      <ButtonCardIcon
        title={t("layouts.navigation.export")}
        icon="parameters"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/settings`,
          });
        }}
      />

      {/*<ButtonCardIcon*/}
      {/*  title="École"*/}
      {/*  icon="school"*/}
      {/*  className="school-button"*/}
      {/*  action={() => {*/}
      {/*    history.push({*/}
      {/*      pathname: `/`,*/}
      {/*    });*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  );
}

QuickLinks.defaultProps = {};
QuickLinks.propTypes = {};

export default memo(QuickLinks);
